module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('div', {
    attrs: {
      "id": "queryArea"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "formItem"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "formItem text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  }), _vm._v(" 更多\n                    ")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "queryDialog",
      "title": "查询信息",
      "width": "90%",
      "visible": _vm.queryDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.queryDialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "系部",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeOption('dept')
      }
    },
    model: {
      value: (_vm.queryForm.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "deptCode", $$v)
      },
      expression: "queryForm.deptCode"
    }
  }, _vm._l((_vm.comboData.dept), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "专业",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeOption('major')
      }
    },
    model: {
      value: (_vm.queryForm.majorCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "majorCode", $$v)
      },
      expression: "queryForm.majorCode"
    }
  }, _vm._l((_vm.comboData.major), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "年级",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeOption('grade')
      }
    },
    model: {
      value: (_vm.queryForm.gradeCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "gradeCode", $$v)
      },
      expression: "queryForm.gradeCode"
    }
  }, _vm._l((_vm.comboData.major), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "班级",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.classCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "classCode", $$v)
      },
      expression: "queryForm.classCode"
    }
  }, _vm._l((_vm.comboData.class), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "placeholder": "审核状态(全部)",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.comboData.auditState), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_vm._v("查 询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重 置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('div', {
    style: ({
      'height': _vm.divHeight - 110 + 'px',
      'overflow': 'auto'
    }),
    attrs: {
      "id": "listArea"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.tableData == null || _vm.tableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有实习变更申请记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学号：")]), _vm._v(_vm._s(item.stuCode))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("姓名：")]), _vm._v(_vm._s(item.stuName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("系部：")]), _vm._v(_vm._s(item.deptName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("专业：")]), _vm._v(_vm._s(item.majorName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("班级：")]), _vm._v(_vm._s(item.className))]), _vm._v(" "), _c('div', {
      staticClass: "auditStateImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadStateImg(item),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.submitState == '1' && item.auditAuth == '0' || item.auditState == '2') ? _c('el-button', {
      attrs: {
        "size": "small",
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.showDetailInfo(item);
        }
      }
    }, [_vm._v("详情\n                    ")]) : _vm._e(), _vm._v(" "), (item.auditAuth == '1') ? _c('el-button', {
      attrs: {
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.auditRec(item);
        }
      }
    }, [_vm._v("审核\n                    ")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' || item.auditState == '1' || item.auditState == '2') ? _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.showAuditList(item);
        }
      }
    }, [_vm._v("审核信息\n                    ")]) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.tableData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍候...\n            ")]) : _vm._e()], 2), _vm._v(" "), (_vm.detailDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "详情",
      "visible": _vm.detailDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialogVisible = $event
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.stuName) + " - " + _vm._s(_vm.selectRowData.stuCode) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原实习单位名称"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.oriUnitName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现实习单位名称"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newUnitName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原实习岗位名称"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.oriPostName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现实习岗位名称"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newPostName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原实习开始时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.oriBeginTime) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现实习开始时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newBeginTime) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原实习结束时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.oriEndTime) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现实习结束时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newEndTime) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原实习薪资"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.oriSalary) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现实习薪资"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newSalary) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原是否岗位对口"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.parseSf(_vm.selectRowData.oriCounterpart)) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现是否岗位对口"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.parseSf(_vm.selectRowData.newCounterpart)) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原是否提供住宿"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.parseSf(_vm.selectRowData.oriPutUp)) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现是否提供住宿"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.parseSf(_vm.selectRowData.newPutUp)) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原单位联系人姓名"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.oriUnitContactsName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现单位联系人姓名"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newUnitContactsName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原单位联系人职务"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.oriUnitContactsDuty) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现单位联系人职务"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newUnitContactsDuty) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原单位联系人电话"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.oriUnitContactsTel) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现单位联系人电话"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newUnitContactsTel) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原单位联系人邮箱"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.oriUnitContactsEmail) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现单位联系人邮箱"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newUnitContactsEmail) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原单位地址"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.oriUnitAddress) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现单位地址"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newUnitAddress) + "\n                    ")])], 1)], 1), _vm._v(" "), (_vm.auditAreaVisible) ? _c('audit', {
    ref: "audit",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "itemCode": _vm.auditParam,
      "relatedCode": _vm.selectRowData.id,
      "auditLevel": _vm.selectRowData.auditLevel
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.selectRowData.id,
      "listHeight": 450
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df52d408"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/practice/practiceChangeMobile.vue
// module id = 1905
// module chunks = 502